export default __webpack_public_path__ + "static/media/Cuprum-BoldItalic.b128bcde.ttf";